/* eslint-disable react/jsx-curly-newline */
/* eslint-disable prettier/prettier */
import React, { useCallback } from 'react';
import { Link } from 'react-router-dom';
import {
  FaRegQuestionCircle,
  FaRegCheckCircle,
  FaRegMoneyBillAlt,
  FaRegThumbsUp,
  FaBan,
  FaRegClock,
  FaRegCalendarCheck,
} from 'react-icons/fa';
// import { Container } from './styles';

import Button from '../Button';

import {
  IFilaChamado,
  IListaAgendamentosHojeDTO,
} from '../../pages/AgendaAtendimento';
import api from '../../services/api';
import { STATUS_AGENDA } from '../../utils/funcoes';
import { Colors } from '../../styles/constants';
import { useAuth } from '../../hooks/auth';

interface IIcons {
  [key: string]: JSX.Element;
}

const icons: IIcons = {
  ban: <FaBan size={15} />,
  question: <FaRegQuestionCircle size={15} />,
  check: <FaRegCheckCircle size={15} />,
  money: <FaRegMoneyBillAlt size={15} />,
  clock: <FaRegClock size={15} />,
  thumbs: <FaRegThumbsUp size={15} />,
  calendar: <FaRegCalendarCheck size={15} />,
};

type listaProps = {
  listaEspera?: IListaAgendamentosHojeDTO[];
  dadosBusca: {
    dataAgenda: string;
    codigoAgenda: string | undefined;
    somenteLista: boolean;
  };
  chamar(pacNome: string): void;
  chamarPainel(dados: IFilaChamado): void;
  abrirHistorico(pacCodigo: number): void;
  sala?: string;
};
const ListaAtendimentoExame: React.FC<listaProps> = ({
  listaEspera,
  dadosBusca,
  chamar,
  chamarPainel,
  abrirHistorico,
  sala = '',
}) => {
  const { clinica } = useAuth();

  const handleImprimir = useCallback((cods: string) => {
    api.get(`/exame/imprimiretiquetas?cods=${cods}`);
  }, []);

  if (listaEspera && listaEspera.length > 0)
    return (
      <>
        <table
          className="table table-hover table-sm table-font-small"
          style={{ borderWidth: '0px' }}
        >
          <tbody>
            <tr className="bg-light" style={{ fontSize: 'Small' }}>
              <th scope="col">&nbsp;</th>
              <th scope="col">Horário</th>
              <th scope="col">Liberado às</th>
              <th scope="col">Paciente</th>
              <th scope="col">Idade</th>
              {clinica.CliExibeConvenioMedico && <th scope="col">Convênio</th>}
              <th scope="col">Celular</th>
              <th scope="col">Procedimento</th>
              <th scope="col">Observação</th>
              <th scope="col">Solicitante</th>
              <th scope="col">Ação</th>
            </tr>
            {listaEspera.map((lista: IListaAgendamentosHojeDTO) => (
              <tr
                key={`lista-${lista.AgeCodigo}`}
                style={{
                  fontSize: 'Small',
                  height: '30px',
                  color:
                    lista.AgeStatus === STATUS_AGENDA.ATENDIDO
                      ? Colors.success
                      : '#000',
                  fontWeight:
                    lista.idadeNumero && lista.idadeNumero >= 80
                      ? 'bold'
                      : 'normal',
                }}
              >
                <td
                  style={{
                    width: '50px',
                    color: lista.icone?.color,
                    textAlign: 'center',
                  }}
                >
                  {icons[lista.icone?.icon || 'question']}
                </td>
                <td style={{ width: '80px' }}>{lista.horario}</td>
                <td style={{ width: '80px' }}>{lista.liberado}</td>
                <td>
                  {lista.PacNomeSocial.trim() !== ''
                    ? `Nome Social: ${lista.PacNomeSocial} - ${lista.PacNome}`
                    : lista.PacNome}
                </td>
                <td>{lista.idade}</td>
                {clinica.CliExibeConvenioMedico && <td>{lista.ConvNome}</td>}
                <td style={{ width: '120px' }}>
                  {`${lista.celular || lista.PacCelular}`}
                </td>
                <td>{lista.Procedimento}</td>
                <td>{lista.AgeObsMedico}</td>
                <td>{lista.solicitante}</td>
                <td className="p-0" style={{ width: '330px' }}>
                  <Link
                    className={`btn btn-primary ${lista.AgeStatus < STATUS_AGENDA.AGUARDANDO_ATENDIMENTO &&
                      lista.AgeStatus !== STATUS_AGENDA.PAGAMENTO_ANTECIPADO
                      ? 'd-none'
                      : ''
                      }`}
                    style={{
                      height: '23px',
                      lineHeight: 1,
                      padding: '4px 16px',
                      fontSize: '14px',
                    }}
                    to={`/pacienteAtendimentoAlvaro/${lista.AgeCodigo.toString()}?agenda=${dadosBusca.codigoAgenda
                      }&data=${dadosBusca.dataAgenda}&somenteLista=${dadosBusca.somenteLista
                      }`}
                  >
                    {lista.atendido ? 'Atendido' : 'Atender'}
                  </Link>
                  &nbsp;&nbsp;
                  {!clinica.CliUsaPainel && (
                    <Button
                      type="button"
                      variant="primary-outline"
                      className={`py-0 ${lista.atendido ||
                        (lista.AgeStatus <
                          STATUS_AGENDA.AGUARDANDO_ATENDIMENTO &&
                          lista.AgeStatus !==
                          STATUS_AGENDA.PAGAMENTO_ANTECIPADO)
                        ? 'd-none'
                        : ''
                        }`}
                      style={{ height: '23px' }}
                      onClick={() =>
                        chamar(
                          lista.PacNomeSocial.trim() !== ''
                            ? `Nome Social: ${lista.PacNomeSocial} - ${lista.PacNome}`
                            : lista.PacNome,
                        )
                      }
                    >
                      Chamar Paciente
                    </Button>
                  )}
                  {clinica.CliUsaPainel && (
                    <Button
                      type="button"
                      variant="primary-outline"
                      className={`py-0 ${lista.atendido ||
                        (lista.AgeStatus <
                          STATUS_AGENDA.AGUARDANDO_ATENDIMENTO &&
                          lista.AgeStatus !==
                          STATUS_AGENDA.PAGAMENTO_ANTECIPADO)
                        ? 'd-none'
                        : ''
                        }`}
                      style={{ height: '23px' }}
                      onClick={() =>
                        chamarPainel({
                          AgeCodigo: lista.AgeCodigo,
                          PacCodigo: lista.PacCodigo,
                          PacNome:
                            lista.PacNomeSocial.trim() !== ''
                              ? lista.PacNomeSocial
                              : lista.PacNome,
                          Sala: sala,
                          Texto: `${lista.PacNomeSocial.trim() !== ''
                            ? lista.PacNomeSocial
                            : lista.PacNome
                            }, ${sala}`,
                        })
                      }
                      disabled={sala === ''}
                    >
                      Chamar Paciente
                    </Button>
                  )}
                  &nbsp;&nbsp;
                  <Button
                    type="button"
                    variant="primary-outline"
                    className="py-0"
                    style={{ height: '23px' }}
                    onClick={() => abrirHistorico(lista.PacCodigo)}
                    title={lista.PacCodigo.toString()}
                  >
                    Histórico
                  </Button>
                  &nbsp;&nbsp;
                  {lista.codItens && (
                    <>
                      <Button
                        type="button"
                        variant="secondary"
                        className={`py-0 ${lista.codItens && lista.codItens !== ''
                          ? ''
                          : 'd-none'
                          }`}
                        title={lista.ExaCodOS}
                        style={{ height: '23px' }}
                        onClick={() => handleImprimir(lista.codItens || '')}
                      >
                        Imprimir
                      </Button>
                      {lista.ExaCodOS}
                    </>
                  )}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </>
    );

  return <div />;
};
export default ListaAtendimentoExame;
